<template>
  <div>
    <h1 class="text-center">Salg</h1>

    <div class="text-center mt-4">
      <p>Der er pt ingen hunde til salg. Men der ventes hvalpe i starten af maj med Hillsbrook Kira. Se mere under hvalpe.</p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Salg',
  computed: {
    ...mapState(['test', 'dogs'])
  }
};
</script>
